// A bookable resource with an empty Workflow-Types / Permitted-Companies array
// means "All" (every option). Expand it to every option id so a filter or
// grouping for any specific value keeps it, instead of bucketing it as
// Unassigned (R9). A non-bookable empty value stays empty → Unassigned, matching
// its "Not Set" cell. Shared by the filter facets and the grouping resolver so
// the two can't diverge.
export function expandAllWhenBookable(
  values: string[],
  isBookable: boolean,
  allIds: string[],
): string[] {
  return isBookable && values.length === 0 ? allIds : values
}
